import { Breadcrumb, PageHeader, TenantGateBanner, TenantGateLock, useTenantGate } from "../../components/ui";
import { BenefitForm } from "../../components/Forms/BenefitForm";

export const NewBenefit = () => {
  const gate = useTenantGate();

  return (
    <>
      <Breadcrumb items={[{ label: "Beneficios", to: "/benefits-catalog" }, { label: "Crear Beneficio" }]} />
    <div className="p-card gap-4 p-3">
      <PageHeader title="Crear Beneficio" />
      {/* §6.4 — el formulario hereda el tenant del header; si está en "Todos"
          no hay a quién asignar el beneficio y la creación se bloquea. */}
      <TenantGateBanner action="crear el beneficio" gate={gate} />
      <TenantGateLock gate={gate}>
        <BenefitForm />
      </TenantGateLock>
    </div>
    </>
  );
};
